import { render } from "./DataStats.vue?vue&type=template&id=159d75fa&scoped=true"
import script from "./DataStats.vue?vue&type=script&lang=js"
export * from "./DataStats.vue?vue&type=script&lang=js"

import "./DataStats.vue?vue&type=style&index=0&id=159d75fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159d75fa"]])

export default __exports__